export default __webpack_public_path__ + "static/media/sheet_thumb16_trip@2x.83405f7b.png";